module.exports = __webpack_public_path__ + "static/img/blane.71646fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blane.png
// module id = nUM0
// module chunks = 1